import Steps from './Steps.jsx';
import Step from './Step.jsx';

Steps.Step = Step;

export { Step };
export default Steps;
